<div class="custom-sort-header-container"
     [class.custom-sort-header-sorted]="isSorted"
     [class.custom-sort-header-descending]="sort.direction === 'desc'"
     [class.custom-sort-header-recently-cleared-ascending]="recentlyCleared === 'asc'"
     [class.custom-sort-header-recently-cleared-descending]="recentlyCleared === 'desc'"
     tabindex="0"
     role="button">
  <div class="custom-sort-header-content">
    <ng-content></ng-content>
  </div>
  <div class="custom-sort-header-arrow">
    <svg viewBox="0 -960 960 960" focusable="false" aria-hidden="true">
      <path d="M440-240v-368L296-464l-56-56 240-240 240 240-56 56-144-144v368h-80Z"/>
    </svg>
  </div>
</div>
